import { format, getDay, parse, startOfWeek } from "date-fns";
import { Event, EventWrapperProps, dateFnsLocalizer, SlotInfo, View } from "react-big-calendar";
import { allDateFnsLocales } from "../../util/getDateFnsLocale";

export type CalendarEvent = Event;

export interface CalendarProps {
  date?: Date;
  onChangeDate?: (newDate: Date) => void;
  viewMode?: View;
  events?: Event[];
  onSelectEvent?: (event: Event, e: React.SyntheticEvent<HTMLElement, globalThis.Event>) => void;
  onSelectDate?: (info: SlotInfo) => void;
  onRangeChange?: (range: Date[] | StartEnd, view?: View | undefined) => void | undefined;
  showAllEvents?: boolean;
  onShowMoreEvents?: (events: Event[], date: Date) => void;

  disablePadding?: boolean;

  badgeComponent?: React.ElementType<EventWrapperProps<Event> & Partial<CalendarProps>>;

  loadingEvents?: boolean;
}

export type StartEnd = {
  start: Date;
  end: Date;
};

export const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales: allDateFnsLocales,
});

export type BadgeStyleProps = {
  topPercent?: string | number;
  isMonth?: boolean;
};

export enum NavigationActionEnum {
  NEXT = "NEXT",
  PREV = "PREV",
  TODAY = "TODAY",
  DATE = "DATE",
}

export enum DiaryType {
  RESOURCES = "resources",
  MONTH = "month",
  WEEK = "week",
  DAY = "day",
  LIST = "list",
}
